import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    meta: { requiresAuth: true },
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '/',
        name: 'dashboard',
        component: () => import('pages/dashboard/DashboardIndex.vue'),
      },
      {
        path: 'school-profile',
        name: 'schoolProfile',
        component: () => import('pages/school-profile/SchoolProfileIndex.vue'),
      },
      {
        path: 'programs',
        name: 'programs',
        component: () => import('pages/programs/ProgramsIndex.vue'),
      },
      {
        path: 'brochures',
        name: 'brochures',
        component: () => import('pages/brochures/BrochuresIndex.vue'),
      },
      {
        path: 'videos',
        name: 'videos',
        component: () => import('pages/videos/VideosIndex.vue'),
      },
      {
        path: 'articles',
        name: 'articles',
        component: () => import('pages/articles/ArticlesIndex.vue'),
      },
      {
        path: 'ambassadors',
        name: 'ambassadors',
        component: () => import('pages/ambassadors/AmbassadorsIndex.vue'),
      },
      {
        path: 'scholarships',
        name: 'scholarships',
        component: () => import('pages/scholarships/ScholarshipsIndex.vue'),
      },
      {
        path: 'scholarships-admin',
        name: 'scholarships-admin',
        component: () => import('pages/scholarships/ScholarshipsIndex.vue'),
      },
      {
        path: 'leads',
        name: 'leads',
        component: () => import('pages/leads/LeadsIndex.vue'),
      },
      {
        path: 'reports',
        name: 'reports',
        component: () => import('pages/reports/ReportsIndex.vue'),
      },
      {
        path: 'media-kit',
        name: 'media-kit',
        component: () => import('pages/media-kit/MediaKitIndex.vue'),
      },
      {
        path: 'schools',
        name: 'schools-admin',
        component: () => import('pages/schools/SchoolsIndex.vue'),
      },
      {
        path: 'articles-admin',
        name: 'articles-admin',
        component: () => import('pages/articles-admin/ArticlesAdminIndex.vue'),
      },
      {
        path: 'users',
        name: 'users',
        component: () => import('pages/users-overview/UsersOverviewIndex.vue'),
        meta: { requiredRole: 'edunakho_admin' },
      },
      {
        path: 'activity',
        name: 'activity',
        component: () => import('pages/activity/ActivityIndex.vue'),
        meta: { requiredRole: 'edunakho_admin' },
      },
      {
        path: 'my-profile',
        name: 'my-profile',
        component: () => import('pages/profile/ProfileIndex.vue'),
      },
      {
        path: 'manage-users',
        name: 'manage-users',
        component: () => import('pages/users/UsersIndex.vue'),
        meta: { requiredRole: 'school_admin' },
      },
    ],
  },
  {
    path: '/login',
    component: () => import('layouts/LoginLayout.vue'),
    children: [
      {
        path: '/login',
        component: () => import('pages/login/LoginIndex.vue'),
        children: [
          {
            path: '/login',
            name: 'login',
            component: () => import('pages/login/LoginForm.vue'),
          },
          {
            path: '/register',
            name: 'register',
            component: () => import('pages/login/RegisterForm.vue'),
          },
        ],
      },
      {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('pages/password/ForgotPassword.vue'),
      },
      {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import('pages/password/ResetPassword.vue'),
      },
    ],
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('pages/login/LogoutIndex.vue'),
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
